import React from "react";
import styled from "styled-components";
import WithIndicator from "root/components/withIndicator";
import t from "common/i18n";
import SvgIcon from "root/components/SvgIcon";
import { globalTheme } from "@cld/component-theme";
import LinkButton from "root/components/LinkButton/LinkButton";
import { FILTERS_BY_MEDIA_TYPE } from "../../data/consts";
import { useSearchParams } from "../../selectors";
import SortBy from "./SortBy";
import License from "./License";
import Orientation from "./Orientation";
import More from "./More";
import Color from "./Color";
import People from "./People";
import Age from "./Age";
import Resolution from "./Resolution";
import Duration from "./Duration";
import Ethnicity from "./Ethnicity";
import SVG_ICONS from "~/assets/icons/icons";

const FiltersBox = styled.div`
	display: flex;
	background: ${globalTheme.palette.surface};
	flex-direction: column;
	height: 535px;
`;

const FiltersHeader = styled.div`
	padding: 0px ${globalTheme.spacing.xs};
	display: flex;
	justify-content: space-between;
	height: 51px;
	border-bottom: 1px solid ${globalTheme.palette.secondary};
`;

const ToggleButton = styled.div`
	display: flex;
	align-items: center;
	> label {
		padding-left: ${globalTheme.spacing.xxs};
	}
`;
const FiltersContainer = styled.div`
	height: 466px;
	overflow: auto;
`;

export default ({ handleSearch, clearSearchFilters, areFiltersSet, isFiltersPanelOpen }) => {
	const { mediaType } = useSearchParams();
	const filterSet = FILTERS_BY_MEDIA_TYPE[mediaType];

	return (
		<FiltersBox data-test={isFiltersPanelOpen ? "filters-panel-open" : null}>
			<FiltersContainer data-test={"filters-panel"}>
				<FiltersHeader>
					<ToggleButton>
						<WithIndicator showIndicator={areFiltersSet} className="flex">
							<SvgIcon size="sm" path={SVG_ICONS.SLIDERS} colorName="menu-icons" />
						</WithIndicator>
						<label>{t("istock.filters.toggle_filters_button")}</label>
					</ToggleButton>
					{areFiltersSet && (
					<LinkButton
						dataTest="istock-filters-clear-button"
						text={t("istock.filters.clear")}
						fontSize={12}
						onClick={clearSearchFilters}
					/>
					)}
				</FiltersHeader>
				<SortBy handleSearch={handleSearch} />
				{filterSet.includes("license") && <License handleSearch={handleSearch} />}
				{filterSet.includes("orientations") && <Orientation handleSearch={handleSearch} />}
				{filterSet.includes("formatAvailable") && <Resolution handleSearch={handleSearch} />}
				{filterSet.includes("duration") && <Duration handleSearch={handleSearch} />}
				{filterSet.includes("numberOfPeople") && <People handleSearch={handleSearch} />}
				{filterSet.includes("ageOfPeople") && <Age handleSearch={handleSearch} />}
				{filterSet.includes("ethnicity") && <Ethnicity handleSearch={handleSearch} />}
				{filterSet.includes("color") && <Color handleSearch={handleSearch} />}
				{filterSet.includes("more") && <More handleSearch={handleSearch} />}
			</FiltersContainer>
		</FiltersBox>
	);
};
